import client from '../httpClient';

const schedulesUpdateApi = (scheduleId, modifyObj) => {
  return client.put(`/schedules/${scheduleId}`, JSON.stringify(modifyObj), { isShowLoading: false });
};

export default schedulesUpdateApi;
